<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="regular-table responsive"
      matSort
      matSortActive="name"
      matSortDirection="asc"
      matSortDisableClear
    >
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Name:</span>
          <span>
            <span>{{ row.name }}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Type:</span>
          <span>
            <span>{{ capitalize(row.type) }}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button
            style="margin-right: 5px"
            mat-flat-button
            *ngIf="hasEditAccess"
            [disabled]="!!templateUsed()"
            (click)="onTemplateEdit(row.id)"
          >
            Edit
          </button>

          <div
            matTooltip="Expansion module not available for this device"
            [matTooltipDisabled]="canTemplateBeUsed(row.type)"
          >
            @if (isExpansionTemplate(row.type)) {
              <button
                mat-flat-button
                [matMenuTriggerFor]="menu"
                [disabled]="!!templateUsed() || !canTemplateBeUsed(row.type)"
                [promiseBtn]="templateUsed() === row.id"
              >
                Use
              </button>

              <mat-menu #menu="matMenu">
                @for (item of availableExpansionDevices(); track $index) {
                  <button mat-menu-item (click)="onTemplateUse(row, item.id)">
                    {{ item.text }}
                  </button>
                }
              </mat-menu>
            } @else {
              <button
                mat-flat-button
                [disabled]="!!templateUsed() || !canTemplateBeUsed(row.type)"
                [promiseBtn]="templateUsed() === row.id"
                (click)="onTemplateUse(row)"
              >
                Use
              </button>
            }
          </div>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
